import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Grunnforurensing extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleGrunnforurensing = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var grunnforurensing = this.props.grunnforurensing
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleGrunnforurensing}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{grunnforurensing.lokalitetsnummer} {grunnforurensing.lokalitetsnavn}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('lokalitetsnummer')}</div>
                            <div className="value">{grunnforurensing.lokalitetsnummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('lokalitetsnavn')}</div>
                            <div className="value">{grunnforurensing.lokalitetsnavn}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('pavirkningsgrad')}</div>
                            <div className="value">{grunnforurensing.pavirkningsgrad}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('myndighet')}</div>
                            <div className="value">{grunnforurensing.myndighet}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('matrikkelforingsdato')}</div>
                            <div className="value"><Moment local>{grunnforurensing.matrikkelforingsdato}</Moment></div>
                        </div>
                        <div className="column">
                            <div className="label">{t('sistoppdatertdato')}</div>
                            <div className="value"><Moment local>{grunnforurensing.sistOppdatertDato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('forsvarsbygg')}</div>
                            <div className="value">{grunnforurensing.forsvarsbygg ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Grunnforurensing)